import { SelectableModel } from '@/types/message.type'

export default {
  all: () => ['conversations'],
  index: (user_id?: string, page?: number, start_model?: SelectableModel) => [
    'conversations',
    { user_id, page, start_model },
  ],
  show: (user_id?: string, conversation_id?: string, client_temp_id?: string) =>
    // Opt-in: only Analytics passes `client_temp_id`. Legacy callers
    // (RMS v2, Search, etc.) continue to use the shorter key so their
    // cache entries are unchanged.
    client_temp_id
      ? ['conversation', { user_id, conversation_id, client_temp_id }]
      : ['conversation', { user_id, conversation_id }],
  rms_show: (conversation_id: string, user_id?: string) => [
    'conversation',
    'rms',
    { user_id, conversation_id },
  ],
  rms_v2_show: (user_id?: string, conversation_id?: string) => [
    'conversation',
    'rms_v2',
    { user_id, conversation_id },
  ],
  for_artifact: (artifact_id?: string, user_id?: string) => [
    'conversation',
    'for_artifact',
    { user_id, artifact_id },
  ],
  // Prefix matching every for_artifact entry — used to invalidate the lookup
  // from a caller that only knows the conversation id, not the artifact.
  for_artifact_all: () => ['conversation', 'for_artifact'],
  generate_name_result: (conversation_id?: string, history_id?: string) => [
    'generate_name_result',
    { conversation_id, history_id },
  ],
  sources: (conversationId?: string) => ['conversation', 'sources', { conversationId }],
  check_onyx_chat_status: (conversationId?: string, messageId?: string) => [
    'conversation',
    'check_onyx_chat_status',
    { conversationId, messageId },
  ],
}
